// Forma de início de um cenário (página de cenário):
//   - Pré-preenchido: parte da base realizada (Orçamento base, 0%) e o ajuste é em %. As células sem
//     base seguem a regra do orçamento base zero e recebem o valor em R$ (ver valueMode.isValueCell).
//   - Zerado: a projeção começa em R$ 0 e a variação é digitada em VALOR (R$), não em %.
//     A base realizada continua visível como referência.
//
// Os cenários de partida fixos (Conservador / Otimista / Pessimista) deram lugar às páginas de cenário,
// com nome livre e renomeável (ver components/ScenarioPages.jsx).

import { emptyAdjustments, INPUT_MODE } from './adjustments';

export const START_MODES = [
  { value: INPUT_MODE.PERCENT, label: 'Pré-preenchido', description: 'Parte da base realizada; ajuste em %. Células sem base recebem o valor em R$.' },
  { value: INPUT_MODE.VALUE, label: 'Zerado', description: 'Projeção começa em R$ 0; digite o valor previsto de cada linha.' },
];

/** Origem gravada no cenário (o backend ainda aceita os nomes dos cenários de partida antigos). */
export const PRESET_ORIGIN = 'base';

/** Estado inicial de um cenário na forma de início escolhida. */
export const startAdjustments = (mode = INPUT_MODE.PERCENT) => emptyAdjustments(mode);
